import React from 'react';
import { ModalOverlay, ModalContainer, ModalHeader, ModalBody, ModalColumn, ModalFooter, ModalButton } from './PlayerDisplayElements';


const PlayerModal = ({ isOpen, onClose, player }) => {
    if (!isOpen) return null;

    console.log(player)

    const commonStats = (
        <>
            <p><span style={{ color: 'blue' }}>Team:</span> {player.team}</p>
            <p><span style={{ color: 'blue' }}>Position:</span> {player.position}</p>
            <p><span style={{ color: 'blue' }}>Salary:</span> ${player.currentSalary}</p>
            <p><span style={{ color: 'blue' }}>Projection:</span> {player.projectedStats ? player.projectedStats.FantasyPointsDraftKings : player.ifDefenseProjectedStats ? player.ifDefenseProjectedStats.FantasyPointsDraftKings : 0.0}</p>
            <p><span style={{ color: 'blue' }}>Total Fantasy Points:</span> {player.seasonStats ? player.seasonStats.FantasyPointsDraftKings : player.ifDefenseProjectedStats ? player.ifDefenseSeasonStats.FantasyPointsDraftKings : 0.0}</p>
            {player.projectedStats && (
                <p><span style={{ color: 'blue' }}>Opponent:</span> {player.projectedStats.Opponent}</p>
            )}
        </>
    );



    const renderStats = () => {
        switch (player.position) {
            case 'QB':
                return (
                    <>
                        <p><span style={{ color: 'blue' }}>Passing Yards:</span> {player.seasonStats.PassingYards}</p>
                        <p><span style={{ color: 'blue' }}>Passing Touchdowns:</span> {player.seasonStats.PassingTouchdowns}</p>
                        <p><span style={{ color: 'blue' }}>Interceptions:</span> {player.seasonStats.PassingInterceptions}</p>
                        <p><span style={{ color: 'blue' }}>Rushing Yards:</span> {player.seasonStats.RushingYards}</p>
                        <p><span style={{ color: 'blue' }}>Rushing Touchdowns:</span> {player.seasonStats.RushingTouchdowns}</p>
                    </>
                );
            case 'RB':
                return (
                    <>
                        <p><span style={{ color: 'blue' }}>Rushing Attempts:</span> {player.seasonStats.RushingAttempts}</p>
                        <p><span style={{ color: 'blue' }}>Rushing Yards:</span> {player.seasonStats.RushingYards}</p>
                        <p><span style={{ color: 'blue' }}>Rushing Touchdowns:</span> {player.seasonStats.RushingTouchdowns}</p>
                        <p><span style={{ color: 'blue' }}>Receptions:</span> {player.seasonStats.Receptions}</p>
                        <p><span style={{ color: 'blue' }}>Receiving Yards:</span> {player.seasonStats.ReceivingYards}</p>
                        <p><span style={{ color: 'blue' }}>Receiving Touchdowns:</span> {player.seasonStats.ReceivingTouchdowns}</p>
                    </>
                );
            case 'WR':
            case 'TE':
                return (
                    <>
                        <p><span style={{ color: 'blue' }}>Receptions:</span> {player.seasonStats.Receptions}</p>
                        <p><span style={{ color: 'blue' }}>Receiving Yards:</span> {player.seasonStats.ReceivingYards}</p>
                        <p><span style={{ color: 'blue' }}>Receiving Touchdowns:</span> {player.seasonStats.ReceivingTouchdowns}</p>
                        <p><span style={{ color: 'blue' }}>Rushing Attempts:</span> {player.seasonStats.RushingAttempts}</p>
                        <p><span style={{ color: 'blue' }}>Rushing Yards:</span> {player.seasonStats.RushingYards}</p>
                    </>
                );
            case 'DST':
                return (
                    <>
                        <p><span style={{ color: 'blue' }}>Sacks:</span> {player.ifDefenseSeasonStats.Sacks}</p>
                        <p><span style={{ color: 'blue' }}>Interceptions:</span> {player.ifDefenseSeasonStats.Interceptions}</p>
                        <p><span style={{ color: 'blue' }}>Fumble Recoveries:</span> {player.ifDefenseSeasonStats.FumblesRecovered}</p>
                        <p><span style={{ color: 'blue' }}>Touchdowns:</span> {player.ifDefenseSeasonStats.FumbleReturnTouchdowns}</p>
                        <p><span style={{ color: 'blue' }}>Points Allowed:</span> {player.ifDefenseSeasonStats.PointsAllowed}</p>
                    </>
                );
            default:
                return commonStats;
        }
    };


    return (
        <ModalOverlay>
            <ModalContainer>
                <ModalHeader>{player.name}</ModalHeader>
                <ModalBody>
                    <ModalColumn>{commonStats}</ModalColumn>
                    <ModalColumn>{renderStats()}</ModalColumn>
                </ModalBody>
                <ModalFooter>
                    <ModalButton onClick={onClose}>Close</ModalButton>
                </ModalFooter>
            </ModalContainer>
        </ModalOverlay>
    );
};

export default PlayerModal;
